import { RegulatorySettings } from './RegulatorySettingsPanel';

// Transform regulatory settings for API
export const transformRegulatorySettings = (settings: RegulatorySettings) => {
    const transformed: any = {};
    
    // Transform institution classification
    if (settings.institution_classification) {
        switch (settings.institution_classification) {
            case 'global_systemically_important_institution':
                transformed.institution_classification = 'Institution classification - Bank is a G-SII, Globally Systemically Important Institution';
                break;
            case 'other_systemically_important_institution':
                transformed.institution_classification = 'Institution classification - Bank is a O-SII, Other Systemically Important Institution';
                break;
            case 'not_systemically_important':
                transformed.institution_classification = 'Institution classification - Bank is not a systemically important institution';
                break;
            default:
                transformed.institution_classification = settings.institution_classification;
        }
    }
    
    // Transform supervisory authority - use the actual official names from the UI options
    if (settings.supervisory_authority) {
        switch (settings.supervisory_authority) {
            case 'ecb':
                transformed.supervisory_authority = 'European Central Bank (ECB)';
                break;
            case 'austria':
                transformed.supervisory_authority = 'Austrian Financial Market Authority';
                break;
            case 'belgium':
                transformed.supervisory_authority = 'National Bank of Belgium';
                break;
            case 'bulgaria':
                transformed.supervisory_authority = 'Bulgarian National Bank';
                break;
            case 'croatia':
                transformed.supervisory_authority = 'Croatian National Bank';
                break;
            case 'cyprus':
                transformed.supervisory_authority = 'Central Bank of Cyprus';
                break;
            case 'czech_republic':
                transformed.supervisory_authority = 'Czech National Bank';
                break;
            case 'denmark':
                transformed.supervisory_authority = 'Danish Financial Supervisory Authority';
                break;
            case 'estonia':
                transformed.supervisory_authority = 'Estonian Financial Supervisory Authority';
                break;
            case 'finland':
                transformed.supervisory_authority = 'Finnish Financial Supervisory Authority';
                break;
            case 'france':
                transformed.supervisory_authority = 'French Prudential Supervision and Resolution Authority';
                break;
            case 'germany':
                transformed.supervisory_authority = 'German Federal Financial Supervisory Authority (BaFin)';
                break;
            case 'greece':
                transformed.supervisory_authority = 'Bank of Greece';
                break;
            case 'hungary':
                transformed.supervisory_authority = 'Hungarian National Bank';
                break;
            case 'ireland':
                transformed.supervisory_authority = 'Central Bank of Ireland';
                break;
            case 'italy':
                transformed.supervisory_authority = 'Bank of Italy';
                break;
            case 'latvia':
                transformed.supervisory_authority = 'Financial and Capital Market Commission (Latvia)';
                break;
            case 'lithuania':
                transformed.supervisory_authority = 'Bank of Lithuania';
                break;
            case 'luxembourg':
                transformed.supervisory_authority = 'Commission de Surveillance du Secteur Financier';
                break;
            case 'malta':
                transformed.supervisory_authority = 'Malta Financial Services Authority';
                break;
            case 'netherlands':
                transformed.supervisory_authority = 'Dutch Central Bank';
                break;
            case 'poland':
                transformed.supervisory_authority = 'Polish Financial Supervision Authority';
                break;
            case 'portugal':
                transformed.supervisory_authority = 'Bank of Portugal';
                break;
            case 'romania':
                transformed.supervisory_authority = 'National Bank of Romania';
                break;
            case 'slovakia':
                transformed.supervisory_authority = 'National Bank of Slovakia';
                break;
            case 'slovenia':
                transformed.supervisory_authority = 'Bank of Slovenia';
                break;
            case 'spain':
                transformed.supervisory_authority = 'Bank of Spain';
                break;
            case 'sweden':
                transformed.supervisory_authority = 'Swedish Financial Supervisory Authority';
                break;
            default:
                transformed.supervisory_authority = settings.supervisory_authority;
        }
    }
    
    // Keep other settings as-is
    if (settings.approach) {
        transformed.approach = settings.approach;
    }
    if (settings.business_model) {
        transformed.business_model = settings.business_model;
    }
    
    return transformed;
};
